import * as angular from "angular";
import {IController} from "angular";
import {PricePlanBundleActionsService} from "../../services/price-plan-bundle-actions.service";

export class PricePlanBundleTableComponent implements IController {
  bundles: any;
  parent: any;
  onSelect: Function;
  refreshList: Function;

  constructor(private pricePlanBundleActionsService: PricePlanBundleActionsService, private $log) {
  }


  duplicate(ev, bundle) {
    this.pricePlanBundleActionsService.duplicateBundle(ev, bundle)
      .then(this.refreshList());
  };

  setAsDefault(ev, bundle) {
    this.pricePlanBundleActionsService.setAsDefault(ev, bundle.id, bundle.name)
      .then(this.refreshList());
  };

  createChild(event, bundle) {
    this.pricePlanBundleActionsService.createChildBundle(event, bundle.id).then(() => this.refreshList()
    )
      .catch((error) => this.$log.debug(error));
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanBundleTable', {
    bindings: {
      bundles: '<',
      parent: '<',
      onSelect: '&',
      refreshList: '&'
    },
    template: require('./price-plan-bundle-table.html').default,
    controller: PricePlanBundleTableComponent
  });
